var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-footer"},[(_vm.currentUser)?_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.currentUser.fullname))]):_vm._e(),_c('span',{staticClass:"copyright"},[_vm._v(" Licenced Loss Adjusters & Investigation © "+_vm._s(new Date().getFullYear())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }